import React from 'react'
import './courseNoticeModal.scss'
import { ossUrl } from '@/api/url'

const CourseNoticeModal = ({ visible, imageUrl, onClose }) => {
  if (!visible) {
    return null
  }

  const formattedUrl = (url) => {
    if (url.length <= 0) return url
    if (url.startsWith('http')) {
      return url
    } else {
      return ossUrl + url
    }
  }

  return (
    <div className="course-notice-modal" onClick={onClose}>
      <div
        className="course-notice-modal__image-layer"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          className="course-notice-modal__image"
          src={formattedUrl(imageUrl)}
          alt="课程领取通知"
        />
        <button
          type="button"
          className="course-notice-modal__close"
          onClick={onClose}
          aria-label="关闭通知弹窗"
        >
          <span className="course-notice-modal__close-icon">×</span>
        </button>
      </div>
    </div>
  )
}

export default CourseNoticeModal
